import {
    BaseGenericRequest,
    getUrlEndpointPrivate,
} from '@cuatroochenta/co-admin-react-library';
import {METHOD} from '@cuatroochenta/co-generic-request';

export interface TaskDeaListRequest {
    filters?: any,
    orderBy?: any,
    order?: 'ASC' | 'DESC',
    maxPerPage?: number,
}

export interface TaskDeaListResponse {
    pages: number,
    results: any[],
    total: number,
}

export default class TaskDeaList extends BaseGenericRequest<{}, TaskDeaListResponse> {

    private readonly data;

    public constructor(data: TaskDeaListRequest) {
        super(METHOD.METHOD_POST, getUrlEndpointPrivate('dea/list/extended/1'));
        this.data = data;
    }

    protected getRequest(): TaskDeaListRequest {
        return this.data
    }
}